/* Ink goes on only once the photo has arrived, so an unloaded image never
   shows as a solid block of ink. The second drum then slides into register. */
(function () {
    'use strict';

    document.querySelectorAll('.riso').forEach(function (riso) {
        var img = riso.querySelector('.riso-layer--a img');
        if (!img) {
            riso.classList.add('is-printed');
            return;
        }

        function printed() {
            riso.classList.add('is-printed');
        }

        if (img.complete && img.naturalWidth > 0) {
            printed();
        } else {
            img.addEventListener('load', printed, {once: true});
            img.addEventListener('error', printed, {once: true});
        }
    });
})();
